<div class="auth-layout d-flex">
    <aside>
        <div class="sidebar">
            <div class="sidebar-body-recovery">
                <form [formGroup]="newPasswordForm">
                    <div class="password-container">
                        <div class="box-content">

                            <ng-container *ngIf="!showSpinner">
                                <div class="back-to-authstep"
                                    (click)="redirectToLogin()">
                                    <svg-icon
                                        src="assets/images/icon-left.svg"></svg-icon>
                                    <span>Voltar para tela inicial</span>
                                </div>

                                <app-spacer [bottom]="93"></app-spacer>


                                <p class="box-title">
                                    {{isCollaborator ? 'Olá colaborador' :
                                    (isRepresentative ? 'Olá representante' :
                                    'Vamos criar uma nova senha')}}
                                </p>

                                <p *ngIf="isCollaborator"
                                    style="margin-top: 8px; margin-bottom: 0; font-size: 18px; font-weight: 600; color: var(--dark, #333);">
                                    Crie sua senha de acesso à plataforma
                                </p>

                                <p *ngIf="isRepresentative"
                                    style="margin-top: 8px; margin-bottom: 0; font-size: 18px; font-weight: 600; color: var(--dark, #333);">
                                    Vamos criar sua senha de acesso
                                </p>

                                <app-spacer [bottom]="48"></app-spacer>

                                <div class="row">

                                    <div class="col-12">
                                        <app-radio [readOnly]="true"
                                            [isChecked]="passwordStrength().includes(1)">
                                            <span class="radio-text"
                                                [class.active]="passwordStrength().includes(1)">Mínimo
                                                de 8
                                                caracteres</span>
                                        </app-radio>
                                        <app-spacer [bottom]="14"></app-spacer>
                                    </div>
                                    <div class="col-12">
                                        <app-radio [readOnly]="true"
                                            [isChecked]="passwordStrength().includes(2)">
                                            <span class="radio-text"
                                                [class.active]="passwordStrength().includes(2)">Mínimo
                                                de 1
                                                número</span>

                                        </app-radio>
                                        <app-spacer [bottom]="14"></app-spacer>
                                    </div>
                                    <div class="col-12">
                                        <app-radio [readOnly]="true"
                                            [isChecked]="passwordStrength().includes(3)">
                                            <span class="radio-text"
                                                [class.active]="passwordStrength().includes(3)">Letras
                                                maiúsculas e
                                                minúsculas</span>
                                        </app-radio>
                                        <app-spacer [bottom]="14"></app-spacer>
                                    </div>
                                    <div class="col-12">
                                        <app-radio [readOnly]="true"
                                            [isChecked]="passwordStrength().includes(4)">
                                            <span class="radio-text"
                                                [class.active]="passwordStrength().includes(4)">Caracteres
                                                especiais</span>
                                        </app-radio>
                                        <app-spacer [bottom]="21"></app-spacer>
                                    </div>

                                    <div class="col-12" *ngIf="!isCollaborator">
                                        <p class="password-description-text">
                                            Para reforçar a segurança
                                            da sua senha, não utilize
                                            informações pessoais como datas de
                                            nascimentos ou números de telefones
                                            e nem números sequenciais.
                                        </p>
                                        <app-spacer [bottom]="32"></app-spacer>
                                    </div>
                                    <div class="col-12" *ngIf="isCollaborator">
                                        <app-spacer [bottom]="32"></app-spacer>
                                    </div>
                                    <div class="col-12">
                                        <app-input type="password"
                                            label="Defina uma senha de acesso"
                                            [group]="newPasswordForm"
                                            controlName="newPassword">
                                        </app-input>
                                        <div class="password-meter">
                                            <p class="password-meter-text">
                                                {{passwordStrengthText()}}</p>

                                            <div class="password-meter-bars">
                                                <div class="password-meter-bar"
                                                    [class.active]="passwordStrengthPercentage() > 30">
                                                </div>
                                                <div class="password-meter-bar"
                                                    [class.active]="passwordStrengthPercentage() > 60">
                                                </div>
                                                <div class="password-meter-bar"
                                                    [class.active]="passwordStrengthPercentage() > 90">
                                                </div>
                                            </div>
                                        </div>
                                        <app-spacer [bottom]="20"></app-spacer>
                                    </div>

                                    <div class="col-12">
                                        <app-input type="password"
                                            label="Confirme sua senha"
                                            [group]="newPasswordForm"
                                            controlName="confirmPassword">
                                        </app-input>

                                        <div *ngIf="showPasswordMismatchError()"
                                            class="text-danger mt-2">
                                            As senhas não coincidem
                                        </div>

                                        <div *ngIf="passwordsMatch() && newPasswordForm.get('confirmPassword')?.touched"
                                            class="text-success mt-2">
                                            ✓ As senhas coincidem
                                        </div>
                                    </div>

                                    <div class="col-12">
                                        <app-spacer [bottom]="32"></app-spacer>
                                        <app-button
                                            [disabled]="newPasswordForm.invalid || loading"
                                            [loading]="loading" [full]="true"
                                            (onClick)="sendPassword()"
                                            [center]="true">
                                            {{isCollaborator ? 'Salvar senha e
                                            entrar' : 'Salvar nova senha e
                                            entrar'}}
                                        </app-button>
                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                </form>
            </div>

            <div class="sidebar-footer">
                Powered by Prosperità Inovação e Tecnologia Ltda © 2018 - 2022
            </div>
        </div>
    </aside>

    <div class="login-background">
    </div>
</div>

<!-- Loading Spinner Fullscreen -->
<app-loading-spinner [active]="showSpinner"></app-loading-spinner>

<!-- Carbon Warning Modal para usuário logado -->
<app-carbon-warning-modal [active]="showLoggedInModal"
    [title]="getLoggedInModalTitle()" [message]="getLoggedInModalMessage()"
    [confirmText]="getLoggedInConfirmText()"
    [cancelText]="getLoggedInCancelText()"
    [confirmAction]="confirmLogoutAndContinue.bind(this)"
    [cancelAction]="cancelAndGoToDashboard.bind(this)"
    (onClose)="cancelAndGoToDashboard()">
</app-carbon-warning-modal>

<!-- Carbon Warning Modal para link inválido -->
<app-carbon-warning-modal [active]="showInvalidLinkModal"
    [title]="getInvalidLinkModalTitle()"
    [message]="getInvalidLinkModalMessage()"
    [confirmText]="getInvalidLinkConfirmText()"
    [cancelText]="getInvalidLinkCancelText()"
    [confirmAction]="closeInvalidLinkModal.bind(this)"
    [cancelAction]="closeInvalidLinkModal.bind(this)"
    (onClose)="closeInvalidLinkModal()">
</app-carbon-warning-modal>